export default __webpack_public_path__ + "static/gdg-3e335f91e5800a48fcc9dba542c81bc7.svg";